<div
  appThrottleClick
  (throttleClick)="navItemSelected()"
  [ngClass]="{ active: viewModel.isNavItemActive$ | async }"
  class="nav-item active custom-nav-item"
  [style.gap.rem]="0.75">
  <div class="nav-item-label" [ngClass]="{ 'multi-line-label': viewModel.multiLineNavItem$ | async }">
    {{ navItem.name }}
  </div>
  <div *ngIf="viewModel.hasIcons$ | async" class="nav-item-icon">
    <img [src]="navItem.iconSrc" alt="icon" i18n-alt class="nav-bar-icon" />
    <img [src]="navItem.iconFilledSrc" alt="icon-filled" i18n-alt class="nav-bar-icon-filled" />
  </div>
</div>
